import { checkIsClaimIdSearchAppplicble } from "./case-search-list-popup";

export const CLAIM_TYPES = {
  HOSPITAL: "I",
  PROFESSIONAL: "P",
};
export const PATIENT_TYPES = {
  INPATIENT: "IP",
  OUTPATIENT: "OP",
};

export const caseSearchTypes = {
  EA_ACCOUNT_CASE_SEARCH: "EA_ACCOUNT_CASE_SEARCH",
  EA_KEY_INFORMATION_CASE_SEARCH: "EA_KEY_INFORMATION_CASE_SEARCH",
};
export const CASE_SEARCH_TYPES = {
  KEY_INFORMATION: "External Audit - Key Info File",
  ACCOUNT_CASE_SEARCH: "External Audit - External File"
}

const patientNameIdentifier =
  "Combination of First Name, Last Name, DOB";
const oneServiceIdentifier = "DOS/Discharge Date";
const thisRowIsMissingFields = "This row is missing required fields.";
const payerRemitNo = "Payer Remit #,";
const accountNosubscriberIDMRn = "Pt Acct No, Subscriber ID, MRN";
const fieldCriteriaMustInclude = "field criteria must include at least";

export const CASE_SEARCH_WARNING_MESSAGES = {
  NON_CASE_SEARCH_PAYER_CASE_ID:
    "The contents of this field for any cases selected will be auto-populated into the corresponding claim Payer Case/Claim ID field in the Audit Case Detail.",
  UNSELECTED_CASES: "This row has unselected Case Search results.",
  ROW_INFORMATION_ICON_MASSAGE_SINGLE_DOS: `${thisRowIsMissingFields} ${fieldCriteriaMustInclude} ${accountNosubscriberIDMRn}, ${patientNameIdentifier} and ${oneServiceIdentifier}.`,
  ROW_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_SINGLE_DOS: `${thisRowIsMissingFields} ${fieldCriteriaMustInclude} ${payerRemitNo} ${accountNosubscriberIDMRn}, ${patientNameIdentifier} and ${oneServiceIdentifier}.`,
  HEADERS_INFORMATION_ICON_MASSAGE_SINGLE_DOS: `For Case Search, ${fieldCriteriaMustInclude} ${accountNosubscriberIDMRn}, ${patientNameIdentifier} and ${oneServiceIdentifier}.`,
  HEADERS_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_SINGLE_DOS: `For Case Search, ${fieldCriteriaMustInclude} ${payerRemitNo} ${accountNosubscriberIDMRn}, ${patientNameIdentifier} and ${oneServiceIdentifier}.`,

  ROW_INFORMATION_ICON_MASSAGE_DOS_RANGE: `${thisRowIsMissingFields} ${fieldCriteriaMustInclude} ${accountNosubscriberIDMRn}, ${patientNameIdentifier}.`,
  ROW_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_DOS_RANGE: `${thisRowIsMissingFields} ${fieldCriteriaMustInclude} ${payerRemitNo} ${accountNosubscriberIDMRn}, ${patientNameIdentifier}.`,
  HEADERS_INFORMATION_ICON_MASSAGE_DOS_RANGE: `For Case Search, ${fieldCriteriaMustInclude} ${accountNosubscriberIDMRn}, ${patientNameIdentifier}.`,
  HEADERS_INFORMATION_ICON_MASSAGE_NON_PRE_PAY_DOS_RANGE: `For Case Search, ${fieldCriteriaMustInclude} ${payerRemitNo} ${accountNosubscriberIDMRn}, ${patientNameIdentifier}.`,
}

export const TEMPLATE_TYPES = {
  MDM: "MDM",
}
/*
  caseSearchWeight - Denotes the weight of case search criteria 
  caseListOrderWeight - Denotes the matching weightage of search critera and it is used to sort the resuts returned by case search 
*/ 
export const getCaseSearchCriteriaMappings = (claimTypeCd, eaAuditType = 'PRE-PAY', templateType = null) => {
  const isMDMLoadTemplate = templateType === TEMPLATE_TYPES.MDM
  let isClaimIdSearchAppplicble = true;
  if(eaAuditType)
    isClaimIdSearchAppplicble = checkIsClaimIdSearchAppplicble(eaAuditType)
  const caseSearchCriteriaFiedMapperObject = Object.freeze({
    case_count: {
      displayAlias: "Case Count",
      keyExpr: "caseCount",
      caseFoundKeyExpr: "caseCount",
      caseSearchWeight: 0,
      caseListOrderWeight: 0,
      excelColumnName :"Case Count"
    },
    subscriber_id: {
      displayAlias: "Subscriber ID",
      keyExpr: "subscriberId",
      caseFoundKeyExpr: "subscriberId",
      caseSearchWeight: 1,
      caseListOrderWeight: 3,
      dynamoDBKeyExpr:"subscriber_id",
      excelColumnName :"Subscriber ID",
      isSuperIdentifier: true,
    },
    patient_name: {
      displayAlias: "Pt Name",
      keyExpr: "patientName",
      caseSearchWeight: 0,
      caseListOrderWeight: 0,
      excelColumnName : "Pt Name",
    },
    patient_acct_no_orig: {
      displayAlias:  "Pt Acct No",
      keyExpr: "patientAcctNoOrig",
      caseFoundKeyExpr: "patientAcctNoOrig",
      caseSearchWeight: isMDMLoadTemplate ? 2: 1,
      caseListOrderWeight: 1,
      isSuperIdentifier: true,
      excelColumnName :isMDMLoadTemplate ? "Patient Control Number" : "Pt Acct No",
    },
    payer_remit_no: {
      displayAlias: "Payer Remit #",
      keyExpr: "payerRemitNo",
      caseFoundKeyExpr: "payerRemitNo",
      caseSearchWeight: 1,
      caseListOrderWeight: 1,
      isSuperIdentifier: true,
      excelColumnName:"Payer Remit #",
    },
    patient_last_name: {
      displayAlias: "Pt Last Name",
      keyExpr: "patientLastName",
      caseFoundKeyExpr: "patientLastName",
      caseSearchWeight: 0.8,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"patient_last_name",
      excelColumnName :isMDMLoadTemplate ? "Recipient Last Name" : "Pt Last Name",
    },
    patient_first_name: {
      displayAlias: "Pt First Name",
      keyExpr: "patientFirstName",
      caseFoundKeyExpr: "patientFirstName",
      caseSearchWeight: 0.8,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"patient_first_name",
      excelColumnName :isMDMLoadTemplate ? "Recipient First Name" : "Pt First Name",
    },
    dob: {
      displayAlias:"DoB",
      keyExpr: "patientDateofBirth",
      caseFoundKeyExpr: "patientDateofBirth",
      caseSearchWeight: 0.8,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"dob",
      excelColumnName :isMDMLoadTemplate ? "Recipient Date of Birth" : "DoB",
    },
    mrn: {
      displayAlias: "MRN",
      keyExpr: "medicalRecordNumber",
      caseFoundKeyExpr: "patientMRN",
      caseSearchWeight: 1,
      caseListOrderWeight: 2,
      dynamoDBKeyExpr:"mrn",
      excelColumnName :"MRN",
      isSuperIdentifier: true,
    },
    dos: {
      displayAlias: "DOS",
      keyExpr: "caseServiceThroughDate",
      caseFoundKeyExpr: "statementToDate",
      caseSearchWeight: 1,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"dos",
      excelColumnName : "DOS",
    },
    service_from_date: {
      displayAlias: "Service From Date",
      keyExpr: "statementFromDate",
      caseFoundKeyExpr: "statementFromDate",
      caseSearchWeight: 0,
      dynamoDBKeyExpr:"",
      caseListOrderWeight: 1,
      excelColumnName :"Service From Date",
    },
    cpt_hcpcs_code: {
      displayAlias: "CPT™/ HCPCS Code",
      keyExpr: "lineCPTHCPCSCode",
      caseFoundKeyExpr: "cpTs",
      caseSearchWeight: 0,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"cpt_hcpcs_code",
      excelColumnName :"CPT™/ HCPCS Code",
    },
    modifier: {
      displayAlias: "Modifier",
      keyExpr: "lineModifier",
      caseFoundKeyExpr: "modifiers",
      caseSearchWeight: 0,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"modifier",
      excelColumnName :"Modifier",
    },
    pos: {
      displayAlias: "POS",
      keyExpr: "linePlaceofService",
      caseFoundKeyExpr: "poSs",
      caseSearchWeight: 0,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"pos",
      excelColumnName :"POS",
    },
    npi: {
      displayAlias:
        claimTypeCd === CLAIM_TYPES.PROFESSIONAL
          ? "Rendering NPI"
          : "Attending NPI",
      keyExpr: "providerNPI",
      caseFoundKeyExpr: "providerNPI",
      caseSearchWeight: 0,
      caseListOrderWeight: 2,
      dynamoDBKeyExpr:"npi",
      excelColumnName :claimTypeCd === CLAIM_TYPES.PROFESSIONAL
      ? "Rendering NPI"
      : "Attending NPI",
    },
    discharge_date: {
      displayAlias: "Discharge Date",
      keyExpr: "inpatientDischargeDate",
      caseFoundKeyExpr: "dischargeDate",
      caseSearchWeight: 1,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"discharge_date",
      excelColumnName :"Discharge Date",
    },
    drg: {
      displayAlias: "DRG",
      keyExpr: "inpatientDRG",
      caseFoundKeyExpr: "drgDiagCode",
      caseSearchWeight: 0,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"drg",
      excelColumnName :"DRG",
    },
    primary_diagnosis: {
      displayAlias: "Primary Diagnosis",
      keyExpr: "primaryDiagnosis",
      caseFoundKeyExpr: "primaryDiagnosis",
      caseSearchWeight: 0,
      caseListOrderWeight: 1,
      dynamoDBKeyExpr:"primary_diagnosis",
      excelColumnName :"Primary Diagnosis",
    },
    claim_id: {
      displayAlias:"Payer Case ID",
      caseFoundKeyExpr: "payerCaseId",
      keyExpr: "payerCaseId",
      caseSearchWeight: isClaimIdSearchAppplicble ? 1 : 0,
      dynamoDBKeyExpr:"claim_id",
      caseListOrderWeight: 1,
      excelColumnName : isMDMLoadTemplate ? "Claim Number": "Payer Case ID",
    },
    retained_amount: {
      displayAlias: "Paid Amount",
      caseFoundKeyExpr: "retainedAmount",
      keyExpr: "retainedAmount",
      dynamoDBKeyExpr:"retained_amount",
      excelColumnName :"Paid Amount",
    }
  });
  let professionalCaseSearchColumnTitles = {}
  let hospitalCaseSearchColumnTitles = {}

  
   var professionalCaseSearchBaseColumnTitles ={
      [caseSearchCriteriaFiedMapperObject.subscriber_id.keyExpr]:
        caseSearchCriteriaFiedMapperObject.subscriber_id.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.patient_acct_no_orig.keyExpr]:
        caseSearchCriteriaFiedMapperObject.patient_acct_no_orig.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.payer_remit_no.keyExpr]:
        caseSearchCriteriaFiedMapperObject.payer_remit_no.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.patient_last_name.keyExpr]:
        caseSearchCriteriaFiedMapperObject.patient_last_name.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.patient_first_name.keyExpr]:
        caseSearchCriteriaFiedMapperObject.patient_first_name.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.dob.keyExpr]:
        caseSearchCriteriaFiedMapperObject.dob.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.mrn.keyExpr]:
        caseSearchCriteriaFiedMapperObject.mrn.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.dos.keyExpr]:
        caseSearchCriteriaFiedMapperObject.dos.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.pos.keyExpr]:
        caseSearchCriteriaFiedMapperObject.pos.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.cpt_hcpcs_code.keyExpr]:
        caseSearchCriteriaFiedMapperObject.cpt_hcpcs_code.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.modifier.keyExpr]:
        caseSearchCriteriaFiedMapperObject.modifier.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.npi.keyExpr]:
        caseSearchCriteriaFiedMapperObject.npi.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.claim_id.keyExpr]:
        caseSearchCriteriaFiedMapperObject.claim_id.excelColumnName,}
    
      const MDMColumns = {
        ...(isMDMLoadTemplate && {
          [caseSearchCriteriaFiedMapperObject.retained_amount.keyExpr]: caseSearchCriteriaFiedMapperObject.retained_amount.excelColumnName,
        })
      };
    professionalCaseSearchColumnTitles=Object.freeze({ ...professionalCaseSearchBaseColumnTitles, ...MDMColumns });
    
    var hospitalCaseSearchBaseColumnTitles = {
      [caseSearchCriteriaFiedMapperObject.subscriber_id.keyExpr]:
        caseSearchCriteriaFiedMapperObject.subscriber_id.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.patient_acct_no_orig.keyExpr]:
        caseSearchCriteriaFiedMapperObject.patient_acct_no_orig.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.payer_remit_no.keyExpr]:
        caseSearchCriteriaFiedMapperObject.payer_remit_no.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.patient_last_name.keyExpr]:
        caseSearchCriteriaFiedMapperObject.patient_last_name.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.patient_first_name.keyExpr]:
        caseSearchCriteriaFiedMapperObject.patient_first_name.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.dob.keyExpr]:
        caseSearchCriteriaFiedMapperObject.dob.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.mrn.keyExpr]:
        caseSearchCriteriaFiedMapperObject.mrn.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.discharge_date.keyExpr]:
        caseSearchCriteriaFiedMapperObject.discharge_date.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.drg.keyExpr]:
        caseSearchCriteriaFiedMapperObject.drg.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.primary_diagnosis.keyExpr]:
        caseSearchCriteriaFiedMapperObject.primary_diagnosis.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.cpt_hcpcs_code.keyExpr]:
        caseSearchCriteriaFiedMapperObject.cpt_hcpcs_code.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.modifier.keyExpr]:
        caseSearchCriteriaFiedMapperObject.modifier.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.npi.keyExpr]:
        caseSearchCriteriaFiedMapperObject.npi.excelColumnName,
      [caseSearchCriteriaFiedMapperObject.claim_id.keyExpr]:
        caseSearchCriteriaFiedMapperObject.claim_id.excelColumnName,
    };
  
  hospitalCaseSearchColumnTitles =Object.freeze({ ...hospitalCaseSearchBaseColumnTitles, ...MDMColumns });
   let caseSearchIdentifiersTmp =  Object.freeze({
    patientIdentifiers: [
      caseSearchCriteriaFiedMapperObject.subscriber_id.keyExpr,
      caseSearchCriteriaFiedMapperObject.payer_remit_no.keyExpr,
      caseSearchCriteriaFiedMapperObject.patient_last_name.keyExpr,
      caseSearchCriteriaFiedMapperObject.patient_acct_no_orig.keyExpr,
      caseSearchCriteriaFiedMapperObject.patient_first_name.keyExpr,
      caseSearchCriteriaFiedMapperObject.dob.keyExpr,
      caseSearchCriteriaFiedMapperObject.mrn.keyExpr,
      caseSearchCriteriaFiedMapperObject.claim_id.keyExpr,
    ],
    serviceIdentifiers: {
      hospitalClaimServiceIdentifiers: [
        caseSearchCriteriaFiedMapperObject.discharge_date.keyExpr,
        caseSearchCriteriaFiedMapperObject.drg.keyExpr,
        caseSearchCriteriaFiedMapperObject.cpt_hcpcs_code.keyExpr,
        caseSearchCriteriaFiedMapperObject.modifier.keyExpr,
        caseSearchCriteriaFiedMapperObject.npi.keyExpr,
        caseSearchCriteriaFiedMapperObject.primary_diagnosis.keyExpr,
      ],
      professionalClaimServiceIdentifiers: [
        caseSearchCriteriaFiedMapperObject.dos.keyExpr,
        caseSearchCriteriaFiedMapperObject.cpt_hcpcs_code.keyExpr,
        caseSearchCriteriaFiedMapperObject.modifier.keyExpr,
        caseSearchCriteriaFiedMapperObject.pos.keyExpr,
        caseSearchCriteriaFiedMapperObject.npi.keyExpr,
      ],
    },
  });
  
  if(isMDMLoadTemplate){
    caseSearchIdentifiersTmp.serviceIdentifiers.hospitalClaimServiceIdentifiers = [
      ...caseSearchIdentifiersTmp.serviceIdentifiers.hospitalClaimServiceIdentifiers,
      caseSearchCriteriaFiedMapperObject.patient_acct_no_orig.keyExpr,
    ];
    caseSearchIdentifiersTmp.serviceIdentifiers.professionalClaimServiceIdentifiers = [
      ...caseSearchIdentifiersTmp.serviceIdentifiers.professionalClaimServiceIdentifiers,
      caseSearchCriteriaFiedMapperObject.patient_acct_no_orig.keyExpr,
    ];
  }
  const caseSearchIdentifiers = Object.freeze(caseSearchIdentifiersTmp)

  return {
    caseSearchCriteriaFiedMapperObject,
    professionalCaseSearchColumnTitles,
    hospitalCaseSearchColumnTitles,
    caseSearchIdentifiers,
  };
};
